var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.195,
    height: 8.5,
    viewBox: "0 0 17.195 8.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-977 -2182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35569",
    "data-name": "Group 35569",
    transform: "translate(977 2182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64106",
    "data-name": "Path 64106",
    d: "M991.645,2183.761a11.264,11.264,0,0,0-12.094,0,2.49,2.49,0,1,0,0,4.979,11.264,11.264,0,0,0,12.094,0,2.49,2.49,0,1,0,0-4.979Zm-9.233,2.49a3.191,3.191,0,1,1,.934,2.251A3.171,3.171,0,0,1,982.412,2186.25Z",
    transform: "translate(-977 -2182)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64107",
    "data-name": "Path 64107",
    d: "M2883.464,2881.732a1.737,1.737,0,1,0-.509,1.223A1.713,1.713,0,0,0,2883.464,2881.732Z",
    transform: "translate(-2873.134 -2877.482)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.34da93b269e11c49c009b96f074c94f4.svg";
export { ForwardRef as ReactComponent };